import styled, { css } from 'styled-components'
import { hideVisually } from 'polished'

const Banner = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${theme.palette.grey[900]};
    color: ${theme.palette.white};
    overflow: hidden;
    padding: ${theme.spacing(7)} ${theme.spacing(5)};

    ${theme.media('md')} {
      padding: ${theme.spacing(10)};
    }
  `}
`

const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(2)};
    background-color: ${theme.palette.white};
    overflow: hidden;

    h4 {
      padding: 0 ${theme.spacing(2)};
    }
  `}
`

const TopicList = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(4)};
    width: 100%;
  `}
`

const Topic = styled.div`
  ${({ theme }) => css`
    max-width: 96rem;
    width: 100%;
    padding: ${theme.spacing(4)} ${theme.spacing(2)};
    border-bottom: 0.1rem solid ${theme.border_color};

    ${theme.media('sm')} {
      padding: ${theme.spacing(4)};
    }

    > header {
      text-align: center;
      margin-bottom: ${theme.spacing(7)};

      h3 {
        margin-top: ${theme.spacing(1)};
      }

      &.small {
        display: flex;
        align-items: center;
        gap: ${theme.spacing(1.5)};
        margin-bottom: ${theme.spacing(3)};

        h3 {
          font-size: 2.4rem;
          margin: 0;
        }

        img {
          margin: 0;
          width: 3.2rem;
        }
      }
    }

    > ul {
      list-style: none;
      padding: 0;
    }
  `}
`

const Question = styled.li`
  ${({ theme }) => css`
    border-top: 0.1rem solid ${theme.border_color};

    &.open button {
      border-bottom: 0.1rem solid ${theme.border_color};
    }

    button {
      appearance: none;
      border: none;
      background-color: transparent;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: ${theme.spacing(2)};
      width: 100%;
      padding: ${theme.spacing(3)} ${theme.spacing(1)};
      font-weight: 400;
      font-size: 1.8rem;
      text-align: left;

      &:hover {
        background-color: ${theme.palette.grey[50]};
      }
    }

    svg {
      flex-shrink: 0;
      color: ${theme.palette.grey[500]};
    }
  `}
`

const Answer = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing(1)} ${theme.spacing(3)};
    font-size: 1.6rem;
    background-color: ${theme.palette.grey[50]};

    ${theme.media('sm')} {
      padding: ${theme.spacing(1)} ${theme.spacing(5)};
    }
  `}
`

const Searchbox = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(2)};
    border-bottom: 0.1rem solid rgba(255, 255, 255, 0.5);
    max-width: 40rem;
    width: 100%;
    transition: border-color 100ms ease-in-out;

    &:has(input:focus) {
      border-color: white;
    }

    input {
      width: 100%;
      padding: ${theme.spacing(1)} 0;
      border: none;
      font-size: 2rem;
      font-weight: 300;
      background-color: transparent;
      color: white;
    }

    input:focus {
      outline: none;
    }

    input::placeholder {
      color: white;
      opacity: 0.5;
    }

    svg {
      flex-shrink: 0;
    }

    button {
      appearance: none;
      border: none;
      font-size: 1.8rem;
      background-color: transparent;
      color: #ffffff;

      &:hover {
        opacity: 0.75;
      }
    }
  `}
`

const Icon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img {
    max-height: 4.8rem;
    max-width: 4.8rem;
  }
`

const QuickLinks = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background-color: ${theme.palette.grey[50]};

    h4 {
      padding: 0 ${theme.spacing(3)};
      margin-bottom: 0;
      font-size: 1.8rem;
    }

    ul {
      display: flex;
      gap: ${theme.spacing(2)};
      list-style: none;
      padding: 0 ${theme.spacing(3)} ${theme.spacing(3)};
      overflow-x: auto;
    }

    a {
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing(1)};
      padding: ${theme.spacing(2)};
      border: 0.1rem solid ${theme.border_color};
      color: ${theme.palette.grey[900]};
      background-color: white;
      min-width: 50vw;

      ${theme.media('sm')} {
        min-width: 40vw;
      }

      &:hover {
        border-color: #000;
      }

      img {
        width: 2.4rem;
      }
    }

    ${theme.media('sm')} {
      ${hideVisually()}
    }
  `}
`

export default {
  Banner,
  Content,
  TopicList,
  Topic,
  Question,
  Answer,
  Searchbox,
  Icon,
  QuickLinks,
}
